import {ROOT_REQUEST} from '@/assets/configs'

//专线列表
export const GET_COMPANY_ROUTE_LINE = `${ROOT_REQUEST.OTMS_API}car/getCompanyRouteLine`

//专线详情
export const GET_COMPANY_ROUTE_LINE_INFO = `${ROOT_REQUEST.OTMS_API}car/getCompanyRouteLineInfo`

//添加或取消收藏接口
export const SAVE_OR_UPDATA_FAVORITE_ORGANIZATION = `${ROOT_REQUEST.OTMS_API}car/saveOrUpdateFavoriteOrganization`

//获取收藏列表
export const GET_FAVORITE_ORGANIZATION = `${ROOT_REQUEST.OTMS_API}car/getFavoriteOrganization`

//保存搜索历史记录
export const SAVE_SEARCH_HISTORY = `${ROOT_REQUEST.OTMS_API}car/saveSearchHistory`

//获取搜索历史记录
export const GET_SEARCH_HISTORY = `${ROOT_REQUEST.OTMS_API}car/getSearchHistory`

//置顶列表
export const GET_COMPANY_ROUTE_LINE_PARK = `${ROOT_REQUEST.OTMS_API}car/getCompanyRouteLinePark`